<ng-template [ngIf]="loaded">
  <div class="row justify-content-center">

    <div class="col-8">
      <div class="row  justify-content-center">
        <h2 class="col-12 titleBookk"><b>{{ 'PROFIL.TITLE' | translate }}</b></h2>


        <!-- spinner -->
        <div *ngIf="IsWait" class="col-12">
          <div class="row justify-content-center mt-4">
            <mat-spinner class="mt-5 titleBookk" strokeWidth="19" [diameter]="100" ></mat-spinner>
          </div>
        </div>


        <!-- Mon profil -->
        <mat-card *ngIf="!IsWait" class="col-12 ">
          <div class="row justify-content-center">
            <div class="col-12 ">
              <div class="row justify-content-center">
                <div class="col-12  col-md-4">
                  <div class="round-img">
                    <img *ngIf="currentUser.profile_picture !== null" class="img-fluid" [src]="getUserImg()">
                    <img *ngIf="currentUser.profile_picture === null" class="img-fluid"
                      src="../assets/img/Picto_Global/profil.jpg" alt="clem">
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <h3 class="col-12 light-font" style="
                      margin: 45px;
                      text-align: left !important;
                  ">{{currentUser.name}}</h3>
                </div>
              </div>
            </div>

            <h4 class="col-12 bold margin-block">{{ 'PROFIL.INFOCONNEXION' | translate }}</h4>

            <div class="row col-12">
              <h5 class="col-12 col-md-6 bolder text-md-right  text-left">
                {{ 'PROFIL.USERNAME' | translate }} :
              </h5>
              <h5 class="col-12 col-md-6" style="text-align: left !important">
                {{currentUser.name}}
              </h5>
            </div>
            <div class="row col-12">
              <h5 class="col-12 col-md-6 bolder text-md-right  text-left">
                {{ 'PROFIL.PASSWORD' | translate }} :
              </h5>
              <h5 class="col-12 col-md-6" style="text-align: left !important">
                ************
              </h5>
            </div>
            <div class="row col-12">
              <h5 class="col-12 col-md-6 bolder text-md-right  text-left">
                {{ 'PROFIL.EMAIL1' | translate }} :
              </h5>
              <h5 class="col-12 col-md-6" style="text-align: left !important">
                {{currentUser.email}}
              </h5>
            </div>
            <div class="row col-12">
              <h5 class="col-12 col-md-6 bolder text-md-right  text-left">
                {{ 'PROFIL.STATUS' | translate }} :
              </h5>
              <h5 class="col-12 col-md-6"  [ngClass]="getStatusClass(currentUser)" style="text-align: left !important">
                {{statusDriver(currentUser)}}
              </h5>
            </div>

          </div>
          <div class="col-12 ">
            <div class="row justify-content-center mt-4 mb-2">

              <button class="col-7 col-md-4" routerLink="/user-password-edit" routerLinkActive="active"
                mat-raised-button color="primary">{{ 'PROFIL.BOUTONMODIFIER1' | translate }}</button>

            </div>

          </div>
        </mat-card>


        <!-- Informations personnelles -->
        <mat-card *ngIf="!IsWait" class="col-12 col-md-12  margin-block">
          <div class="row">
            <h3 class="col-12 bold margin-block ">{{ 'PROFIL.INFOPERSONNELLE' | translate }}</h3>
            <div class="col-12 col-md-6 margin-block-s  hrline">
              <div class="row ">
                <h5 class="col-12 col-sm-12 bolder text-sm-center  text-center clem-green-font">
                  {{ 'PROFIL.ETATCIVIL' | translate }} :
                </h5>

                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.NOM' | translate }} :
                </h5>
                <h5 class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser.lastname}}
                </h5>
                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.PRENOM' | translate }} :
                </h5>
                <h5 class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser.firstname}}
                </h5>

                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.NAISSANCE' | translate }} :
                </h5>
                <h5 class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser.birthdate}}
                </h5>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <h5 class="col-12 col-sm-12 bolder text-sm-center  text-center clem-green-font">
                  {{ 'PROFIL.VOSINFORMATIONS' | translate }} :
                </h5>

                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.TEL' | translate }} :
                </h5>
                <h5 class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser.phonenumber}}
                </h5>
                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.EMAIL2' | translate }} :
                </h5>
                <h5 class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser.email}}
                </h5>
                <h5 *ngIf="currentUser.company" class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.COMPANY' | translate }} :
                </h5>
                <h5 *ngIf="currentUser.company" class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser.company}}
                </h5>
                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.COMMUNITY' | translate }} :
                </h5>
                <h5 *ngIf="currentUser.community" class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser?.community?.name}}
                </h5>
                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'PROFIL.RFID' | translate }} :
                </h5>
                <h5 class="col-12 col-sm-6" style="text-align: left !important">
                  {{currentUser.rfid}}
                </h5>



              </div>
            </div>

          </div>


          <div class="col-12 ">
            <div class="row justify-content-center mt-4 mb-2">

              <button class="col-7 col-md-4" routerLink="/user-edit" routerLinkActive="active" mat-raised-button
                color="primary">{{ 'PROFIL.BOUTONMODIFIER2' | translate }}</button>

            </div>
          </div>

        </mat-card>


        <!-- code promo -->
        <mat-card *ngIf="!IsWait && currentUser?.community?.parrain === true" class="col-12 col-md-12  margin-block">

          <div class="row">
            <h3 class="col-12 bold margin-block ">{{ 'PROFIL.CODEPROMOPARRAIN' | translate }}</h3>
          </div>

          <div class="row justify-content-center">
            <h4 class="col-10 bold ">Partagez votre code promo de 5€ avec vos amis, s'ils l’utilisent pour
              leur première réservation dans la même communauté d’inscription, vous profiterez chacun de 5€ de
              réduction. Vous pouvez accumuler plusieurs crédits parrain mais ils ne sont pas cumulables par
              réservation.</h4>
          </div>

          <div class="col-12 ">


            <div *ngIf="!IsWait && code_promo?.isGet === false" class="row justify-content-center mt-4 mb-2">
              <button class="col-7 col-md-4" (click)="postCodePromo()" routerLinkActive="active" mat-raised-button
                color="primary">{{ 'PROFIL.BOUTONPROMO' | translate }}</button>
            </div>

            <div *ngIf="!IsWait && code_promo?.isGet === true" class="row justify-content-center mt-3 mb-2">
                <div class="col-sm-auto col-12 adressmar mb-2">
                  <label style="font-size: 25px;" class="col-12">
                  
                   <span style="font-size: 16px !important" >{{ 'PROFIL.CODEPROMO'  | translate }}</span>  : {{code_promo?.code}}
                    <mat-icon matTooltip="Copier" class="spanLink"  (click)="copyMessage(code_promo?.code)" aria-hidden="false" aria-label="Adresse">file_copy</mat-icon>
                  </label>
                </div>
              </div>

              <div *ngIf="!IsWait && code_promo?.avaible >= 1" class="row justify-content-center mt-3 mb-2">
                <div class="col-sm-auto col-12 adressmar mb-2">
                  <label style="font-size: 15px;" class="col-12">
                  
                   <span style="font-size: 16px !important" >{{ 'PROFIL.CREDIT'  | translate }}</span>  : {{code_promo?.avaible}}
                  </label>
                </div>
              </div>
            



          </div>

        </mat-card>



        <!-- justificatif permis -->
        <mat-card *ngIf="!IsWait" class="col-12  margin-block ">
          <div class="row">
            <h3 class="col-12 bold">{{ 'PROFIL.PERMIS' | translate }}</h3>
          </div>

          <div *ngIf="iSupdatePermis" class="row justify-content-center">
            <h5 class="col-12 col-md-8 faces">{{ 'PROFIL.OUBLIER' | translate }}</h5>
          </div>

          <div *ngIf="iSupdatePermis" class="row justify-content-center">
            <h5 class="col-12 col-md-8 avert">{{ 'PROFIL.ATTENTION1' | translate }}</h5>
          </div>


          <form [formGroup]="uploadFormPermis">

            <div class="row">
              <!-- permis recto -->
              <div class="col-12 col-md-6  hrline">

                <div class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <img
                      *ngIf="currentUser?.license?.source !== null && currentUser?.license?.mimetype !== 'application/pdf'"
                      class="img-fluid" [src]="getPermisImg()">
                    <h3 *ngIf="currentUser?.license?.source === null" class="col-12 margin-block ">{{
                      'PROFIL.AUCUNJUSTIFICATIF1' | translate }}
                    </h3>

                    <div
                      *ngIf="currentUser?.license?.source !== null && currentUser?.license?.mimetype === 'application/pdf'"
                      class="col-12 mt-4">
                      <div class="row justify-content-center">
                        <img class="mr-3" height="30" src="../assets/img/Picto_Global/pdf.png" alt="clem">
                        <a class="" [href]="getPermisImg()" download="permis.pdf">{{currentUser.license?.filename}}</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="iSupdatePermis" class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <mat-form-field class="columns">
                      <mat-label *ngIf="nameFilePermis; else newFile">{{nameFilePermis}}</mat-label>
                      <ng-template #newFile>
                        <mat-label>{{ 'PROFIL.FICHIER1' | translate }}</mat-label>
                      </ng-template>
                      <input matInput disabled>
                      <button mat-icon-button matSuffix (click)="fileInput.click()">
                        <mat-icon>attach_file</mat-icon>
                      </button>
                      <input name="license" hidden (change)="fileChangePermis($event)" #fileInput type="file" id="file"
                        accept="image/*,application/pdf">
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- permis verso -->
              <div class="col-12 col-md-6">

                <div class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <img
                      *ngIf="currentUser?.license_back?.source !== null && currentUser?.license_back?.mimetype !== 'application/pdf'"
                      class="img-fluid" [src]="getPermisversoImg()">
                    <h3 *ngIf="currentUser?.license_back?.source === null" class="col-12 margin-block">{{
                      'PROFIL.AUCUNJUSTIFICATIF2' | translate }}
                    </h3>

                    <div
                      *ngIf="currentUser?.license_back?.source !== null && currentUser?.license_back?.mimetype === 'application/pdf'"
                      class="col-12">
                      <div class="row justify-content-center">
                        <img class="mr-3" height="30" src="../assets/img/Picto_Global/pdf.png" alt="clem">
                        <a class="" [href]="getPermisversoImg()"
                          download="permis.pdf">{{currentUser.license_back?.filename}}</a>
                      </div>
                    </div>
                  </div>
                </div>


                <div *ngIf="iSupdatePermis" class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <mat-form-field class="columns">
                      <mat-label *ngIf="nameFilePermisBack; else newFileBack">{{nameFilePermisBack}}</mat-label>
                      <ng-template #newFileBack>
                        <mat-label>{{ 'PROFIL.AUCUNJUSTIFICATIF2' | translate }}</mat-label>
                      </ng-template>
                      <input matInput disabled>
                      <button mat-icon-button matSuffix (click)="fileInputBack.click()">
                        <mat-icon>attach_file</mat-icon>
                      </button>
                      <input name="license_back" hidden (change)="fileChangePermisBack($event)" #fileInputBack
                        type="file" id="file" accept="image/*,application/pdf">
                    </mat-form-field>


                  </div>
                </div>
              </div>
            </div>

            <!-- valider -->
            <div class="row mt-4">
              <div class="col-12 ">
                <div class="row justify-content-center">
                  <button *ngIf="iSupdatePermis" class="col-7 col-md-4" mat-button mat-stroked-button type="submit"
                    (click)="sendPermis()" color="primary">{{ 'PROFIL.BOUTONVALIDER1' | translate }}
                  </button>
                </div>
              </div>
            </div>

          </form>

          <div class="col-12 ">
            <div class="row justify-content-center mt-4 mb-2">
              <button *ngIf="!iSupdatePermis && currentUser?.permis === false" class="col-7 col-md-4"
                (click)="updatePermis()" routerLinkActive="active" mat-raised-button color="primary">{{
                'PROFIL.BOUTONMODIFIER3' | translate }}
              </button>

            </div>
          </div>
        </mat-card>



        <!-- selfie -->
        <mat-card *ngIf="!IsWait && currentUser?.selfie_file?.file !== null" class="col-12  margin-block ">
          <div class="row">
            <h3 class="col-12 bold">{{ 'PROFIL.SELFIE' | translate }}</h3>
          </div>
          <!-- selfie -->
          <div *ngIf="!iSupdateSelfie" class="row justify-content-center">
            <div class="col-12 col-md-6 ">
              <div class="row justify-content-center">
                <img *ngIf="currentUser?.selfie_file?.file !== null" class="img-fluid" [src]="getSelfieImg()">
              </div>
            </div>
          </div>

          <!-- modifier buton -->
          <div *ngIf="!iSupdateSelfie && currentUser?.permis === false" class="row justify-content-center mt-4 mb-2">
            <button class="col-7 col-md-4" (click)="updateSelfie()" routerLinkActive="active" mat-raised-button
              color="primary">{{ 'PROFIL.BOUTONMODIFIER3' | translate }}
            </button>

          </div>


          <!-- picture -->
          <div *ngIf="iSupdateSelfie" class="row justify-content-center">
            <video class="col-11 col-lg-8 sbordure" [class.show]="!isCaptured" [class.hide]="isCaptured" #video
              id="video" [width]="640" autoplay></video>
            <canvas class="col-11 col-lg-8 sbordure" [class.show]="isCaptured" [class.hide]="!isCaptured" #canvas
              id="canvas" [width]="WIDTH" [height]="HEIGHT"></canvas>
          </div>
          <!-- capture -->
          <div *ngIf="iSupdateSelfie" class="row justify-content-center">
            <button class="col-8 col-md-4 mt-3 photo-bouton" mat-raised-button *ngIf="!isCaptured" color="primary"
              (click)="capture()">Prendre une photo</button>
            <button class="col-8 col-md-4 mt-3 photo-bouton" mat-raised-button *ngIf="isCaptured" color="primary"
              (click)="removeCurrent()">Prendre une autre photo</button>
          </div>

          <!-- valider -->
          <div class="row mt-4">
            <div class="col-12 ">
              <div class="row justify-content-center">
                <button *ngIf="isCaptured" class="col-7 col-md-4" mat-button mat-stroked-button type="submit"
                  (click)="sendSelfie()" color="primary">{{ 'PROFIL.BOUTONVALIDER1' | translate }}
                </button>
              </div>
            </div>
          </div>



        </mat-card>



        <!-------------------------------- Selfie ----------------------------------->
        <!-- <div   class="row justify-content-center mt-5">
      <mat-card class="col-11 col-lg-7 bordure">
        <mat-card-content>


          <h2 class="text-center primary-font"><b>{{ 'FORM.SELFIE' | translate }}</b></h2>

          <h5 style="font-size: 14px !important;" class="text-center primary-font"><b>{{ 'FORM.SELFIEDESC' | translate }}</b></h5>

          <div class="row justify-content-center">


            <video class="col-11 col-lg-8 sbordure" [class.show]="!isCaptured" [class.hide]="isCaptured" #video
              id="video" [width]="640" autoplay></video>

            <canvas class="col-11 col-lg-8 sbordure" [class.show]="isCaptured" [class.hide]="!isCaptured" #canvas
              id="canvas" [width]="WIDTH" [height]="HEIGHT"></canvas>
          </div>

          <div class="row justify-content-center">
            <button class="col-8 col-md-4 mt-3 photo-bouton" mat-raised-button 
              *ngIf="!isCaptured" color="primary" (click)="capture()">Prendre une photo</button>
            <button class="col-8 col-md-4 mt-3 photo-bouton" mat-raised-button *ngIf="isCaptured" color="primary"
              (click)="removeCurrent()">Prendre une autre photo</button>

          </div>





        </mat-card-content>
      </mat-card>

    </div> -->





        <!-- justificatif -->
        <mat-card *ngIf="!IsWait" class="col-12  margin-block ">
          <div class="row">
            <h3 class="col-12 bold margin-block ">{{ 'PROFIL.JUSTIFICATIFS' | translate }}</h3>
          </div>

          <div *ngIf="iSupdateAttachments" class="row justify-content-center">
            <h5 class="col-12 col-md-8 avert">{{ 'PROFIL.ATTENTION2' | translate }}</h5>
          </div>

          <form [formGroup]="uploadFormAttachements">



            <div class="row">
              <!-- justificatif 1 -->
              <div class="col-12 col-md-6  hrline">

                <div class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <img
                      *ngIf="currentUser.attachments[0] !== undefined && currentUser.attachments[0]?.mimetype !== 'application/pdf'"
                      class="img-fluid" [src]="getAttachement1()">
                    <h3 *ngIf="currentUser.attachments[0] === undefined" class="col-12 margin-block ">{{
                      'PROFIL.AUCUNJUSTIFICATIF3' | translate }}
                    </h3>

                    <div
                      *ngIf="currentUser.attachments[0] !== undefined && currentUser.attachments[0]?.mimetype === 'application/pdf'"
                      class="col-12">
                      <div class="row justify-content-center">
                        <img class="mr-3" height="30" src="../assets/img/Picto_Global/pdf.png" alt="clem">
                        <a class="" [href]="getAttachement1()"
                          download="justificatif.pdf">{{currentUser.attachments[0]?.filename}}</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="iSupdateAttachments" class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <mat-form-field class="columns">
                      <mat-label *ngIf="nameFileAttachement1; else newFileAttachment1">{{nameFileAttachement1}}
                      </mat-label>
                      <ng-template #newFileAttachment1>
                        <mat-label>{{ 'PROFIL.FICHIER3' | translate }}</mat-label>
                      </ng-template>
                      <input matInput disabled>
                      <button mat-icon-button matSuffix (click)="fileInputAttachement1.click()">
                        <mat-icon>attach_file</mat-icon>
                      </button>
                      <input name="attachement1" hidden (change)="fileChangeAttachement1($event)" #fileInputAttachement1
                        type="file" id="file" accept="image/*,application/pdf">
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- justificatif 2 -->
              <div class="col-12 col-md-6 justif2">

                <div class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <img
                      *ngIf="currentUser.attachments[1] !== undefined && currentUser.attachments[1]?.mimetype !== 'application/pdf'"
                      class="img-fluid" [src]="getAttachement2()">
                    <h3 *ngIf="currentUser.attachments[1] === undefined" class="col-12 margin-block ">{{
                      'PROFIL.AUCUNJUSTIFICATIF4' | translate }}
                    </h3>

                    <div
                      *ngIf="currentUser.attachments[1] !== undefined && currentUser.attachments[1]?.mimetype === 'application/pdf'"
                      class="col-12">
                      <div class="row justify-content-center">
                        <img class="mr-3" height="30" src="../assets/img/Picto_Global/pdf.png" alt="clem">
                        <a class="" [href]="getAttachement2()"
                          download="justificatif.pdf">{{currentUser.attachments[1]?.filename}}</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="iSupdateAttachments" class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <mat-form-field class="columns">
                      <mat-label *ngIf="nameFileAttachement2; else newFileAttachment2">{{nameFileAttachement2}}
                      </mat-label>
                      <ng-template #newFileAttachment2>
                        <mat-label>{{ 'PROFIL.FICHIER4' | translate }}</mat-label>
                      </ng-template>
                      <input matInput disabled>
                      <button mat-icon-button matSuffix (click)="fileInputAttachement2.click()">
                        <mat-icon>attach_file</mat-icon>
                      </button>
                      <input name="attachement2" hidden (change)="fileChangeAttachement2($event)" #fileInputAttachement2
                        type="file" id="file" accept="image/*,application/pdf">
                    </mat-form-field>

                  </div>
                </div>

              </div>

            </div>


            <div class="row">
              <!-- justificatif 3 -->
              <div class="col-12 col-md-6  hrline">

                <div class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <img
                      *ngIf="currentUser.attachments[2] !== undefined && currentUser.attachments[2]?.mimetype !== 'application/pdf'"
                      class="img-fluid" [src]="getAttachement3()">
                    <h3 *ngIf="currentUser.attachments[2] === undefined" class="col-12 margin-block ">{{
                      'PROFIL.AUCUNJUSTIFICATIF3' | translate }}
                    </h3>

                    <div
                      *ngIf="currentUser.attachments[2] !== undefined && currentUser.attachments[2]?.mimetype === 'application/pdf'"
                      class="col-12">
                      <div class="row justify-content-center">
                        <img class="mr-3" height="30" src="../assets/img/Picto_Global/pdf.png" alt="clem">
                        <a class="" [href]="getAttachement3()"
                          download="justificatif.pdf">{{currentUser.attachments[2]?.filename}}</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="iSupdateAttachments" class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <mat-form-field class="columns">
                      <mat-label *ngIf="nameFileAttachement3; else newFileAttachment3">{{nameFileAttachement3}}
                      </mat-label>
                      <ng-template #newFileAttachment3>
                        <mat-label>{{ 'PROFIL.FICHIER3' | translate }}</mat-label>
                      </ng-template>
                      <input matInput disabled>
                      <button mat-icon-button matSuffix (click)="fileInputAttachement3.click()">
                        <mat-icon>attach_file</mat-icon>
                      </button>
                      <input name="attachement3" hidden (change)="fileChangeAttachement3($event)" #fileInputAttachement3
                        type="file" id="file" accept="image/*,application/pdf">
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- justificatif 4 -->
              <div class="col-12 col-md-6 justif2">

                <div class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <img
                      *ngIf="currentUser.attachments[3] !== undefined && currentUser.attachments[3]?.mimetype !== 'application/pdf'"
                      class="img-fluid" [src]="getAttachement4()">
                    <h3 *ngIf="currentUser.attachments[3] === undefined" class="col-12 margin-block ">{{
                      'PROFIL.AUCUNJUSTIFICATIF4' | translate }}
                    </h3>

                    <div
                      *ngIf="currentUser.attachments[3] !== undefined && currentUser.attachments[3]?.mimetype === 'application/pdf'"
                      class="col-12">
                      <div class="row justify-content-center">
                        <img class="mr-3" height="30" src="../assets/img/Picto_Global/pdf.png" alt="clem">
                        <a class="" [href]="getAttachement4()"
                          download="justificatif.pdf">{{currentUser.attachments[3]?.filename}}</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="iSupdateAttachments" class="col-12 col-sm-12">
                  <div class="row justify-content-center">
                    <mat-form-field class="columns">
                      <mat-label *ngIf="nameFileAttachement4; else newFileAttachment4">{{nameFileAttachement4}}
                      </mat-label>
                      <ng-template #newFileAttachment4>
                        <mat-label>{{ 'PROFIL.FICHIER4' | translate }}</mat-label>
                      </ng-template>
                      <input matInput disabled>
                      <button mat-icon-button matSuffix (click)="fileInputAttachement4.click()">
                        <mat-icon>attach_file</mat-icon>
                      </button>
                      <input name="attachement4" hidden (change)="fileChangeAttachement4($event)" #fileInputAttachement4
                        type="file" id="file" accept="image/*,application/pdf">
                    </mat-form-field>

                  </div>
                </div>

              </div>

            </div>




            <!-- valider -->
            <div class="row mt-4">
              <div class="col-12">
                <div class="row justify-content-center mt-4 mb-2">
                  <button (click)="sendAttachements()" type="submit" *ngIf="iSupdateAttachments" class="col-7 col-md-4"
                    mat-button mat-stroked-button color="primary">{{ 'PROFIL.BOUTONVALIDER2' | translate }}
                  </button>
                </div>
              </div>
            </div>

          </form>



          <div class="col-12 ">
            <div class="row justify-content-center mt-4 mb-2">
              <button *ngIf="!iSupdateAttachments && currentUser?.permis === false" class="col-8 col-md-4"
                (click)="updateAttachments()" mat-raised-button color="primary">{{ 'PROFIL.BOUTONAJOUTERMODIFIER' |
                translate }}
              </button>

            </div>
          </div>

        </mat-card>








        <!-- Rachat de franchise -->
        <!-- <mat-card *ngIf="!IsWait && isMamSncf() === false" class="col-12  margin-block ">
          <div class="row">
            <h3 class="col-12 bold margin-block ">{{ 'PROFIL.FRANCHISE' | translate }}</h3>
          </div>


          <mat-accordion class="">
            <mat-expansion-panel class="categorie titleBookkBack pt-5" [expanded]="true" (opened)="categorie1 = true"
              (closed)="categorie1 = false">
      
              <mat-expansion-panel class="question" [expanded]="true" (opened)="question1_1 = true"
                (closed)="question1_1 = false">
                <mat-expansion-panel-header class="panelheader1">
                  <mat-panel-title>
                    <p class="childbloc">
                      {{ 'PROFIL.FRANCHISEVOITURE' | translate }} :
                    </p>
                  </mat-panel-title>

                </mat-expansion-panel-header>

                <a class="textbloc" target="_blank" href="https://serenitrip.fr/?a=clem">{{ 'PROFIL.FRANCHISECLICK' |
                  translate }}</a><br />

              </mat-expansion-panel>

              <mat-expansion-panel class="question" [expanded]="true" (opened)="question1_2 = true"
                (closed)="question1_2 = false">
                <mat-expansion-panel-header class="panelheader1">
                  <mat-panel-title>
                    <p class="childbloc">
                      {{ 'PROFIL.FRANCHISEUTILITAIRE' | translate }} :
                    </p>
                  </mat-panel-title>

                </mat-expansion-panel-header>

                <a class="textbloc" target="_blank" href="https://serenitrip-utilitaire.fr/?a=ClemUtilitairePart">{{
                  'PROFIL.FRANCHISECLICK' | translate }}</a><br />

              </mat-expansion-panel>
            </mat-expansion-panel>
          </mat-accordion>







        </mat-card> -->

        <!-- user service  -->
        <mat-card *ngIf="!IsWait && isMamSncf() === false" class="col-12  margin-block ">
          <div class="row">
            <div class="col" style="text-align: center">
              <mat-icon svgIcon="autopartage" style="height: 75px; width: 75px; text-align: center;"></mat-icon>
              <h4>{{ 'PROFIL.AUTOPARTAGE' | translate }}</h4>

              <div *ngIf="currentUser.autopartage; else NoAutopargeBlock">
                <div *ngIf="currentUser.permis; else NoPermisBlock">
                  <mat-icon style="color: green; height: 40px; width: 40px; text-align: center;">check</mat-icon>
                </div>
                <ng-template #NoPermisBlock>
                  <mat-icon style="color: orange ; height: 40px; width: 40px; text-align: center;"
                    matTooltip="Permis non validé">warning</mat-icon>
                </ng-template>
              </div>
              <ng-template #NoAutopargeBlock>
                <mat-icon style="color: red ; height: 40px; width: 40px; text-align: center;"
                  matTooltip="service non selectionné">cancel</mat-icon>
              </ng-template>
            </div>
            <!-- recharge -->
            <div class="col" style="text-align: center">
              <mat-icon svgIcon="recharge" style="height: 75px; width: 75px; text-align: center;"></mat-icon>
              <h4>{{ 'PROFIL.RECHARGE' | translate }}</h4>

              <div *ngIf="currentUser.recharge; else NoAutopargeBlock">
                <mat-icon style="color: green">check</mat-icon>
              </div>
              <ng-template #NoAutopargeBlock>
                <mat-icon style="color: red " matTooltip="service non selectionné">cancel</mat-icon>
              </ng-template>
            </div>
            <!-- velo -->
            <div class="col" style="text-align: center">
              <mat-icon svgIcon="velo" style="height: 75px; width: 75px; text-align: center;"></mat-icon>
              <h4>{{ 'PROFIL.VELO' | translate }}</h4>

              <div *ngIf="currentUser.velo; else NoAutopargeBlock">
                <mat-icon style="color: green">check</mat-icon>
              </div>
              <ng-template #NoAutopargeBlock>
                <mat-icon style="color: red" matTooltip="service non selectionné">cancel</mat-icon>
              </ng-template>
            </div>
            <!-- partage trajet -->
            <div class="col" style="text-align: center">
              <mat-icon svgIcon="partage-trajet" style="height: 75px; width: 75px; text-align: center;"></mat-icon>
              <h4>{{ 'PROFIL.PARTAGETRAJET' | translate }}</h4>

              <div *ngIf="currentUser.partage_trajet; else NoAutopargeBlock">
                <mat-icon style="color: green">check</mat-icon>
              </div>
              <ng-template #NoAutopargeBlock>
                <mat-icon style="color: red" matTooltip="service non selectionné">cancel</mat-icon>
              </ng-template>
            </div>
          </div>


        </mat-card>





        <!-- désinscrire -->
        <mat-card *ngIf="!IsWait" class="col-12 mt-3">
          <div class="row justify-content-center">


            <!-- <h4 class="col-12 bold margin-block">Désinscription</h4> -->




          </div>
          <div class="col-12 ">
            <div class="row justify-content-center mt-4 mb-2">

              <button class="col-7 col-md-4" (click)="unsubscribeUser()" mat-raised-button color="primary">{{
                'PROFIL.DESINSCRIRE' | translate }}</button>

            </div>

          </div>
        </mat-card>


      </div>
    </div>
  </div>
</ng-template>